import { createVanIconComponent } from "./van"

const FireOutlined = createVanIconComponent("fire-o")
export default FireOutlined
